import { useContext } from "react";
import * as Sentry from "@sentry/browser";
import { Redirect } from "react-router-dom";
import {
  HELPSCOUT_BEACON_PAGE,
  SUBMISSION_CATEGORY,
  SUBMISSION_TYPE_MODULE,
} from "common/constants";
import { arrayHasAtLeastOneItem } from "common/utils/arrays";
import { AuthContext } from "../../Authorization/AuthContext";
import { CreateSubmission } from "../../Submissions/CreateSubmission";
import { useHelpscoutBeacon } from "../utils";

const UploadElevationCertificatesPage = () => {
  const { account } = useContext(AuthContext);

  useHelpscoutBeacon(HELPSCOUT_BEACON_PAGE.EC);

  const submissionTypes = account?.submissionTypes.filter(
    type =>
      type.category === SUBMISSION_CATEGORY.PERMITTING &&
      type.canCreate.includes("guest") &&
      type.modules.includes(SUBMISSION_TYPE_MODULE.EC_SUBMISSION),
  );

  if (!arrayHasAtLeastOneItem(submissionTypes)) {
    return <Redirect to={"/"} />;
  }

  if (submissionTypes.length > 1) {
    Sentry.captureMessage(
      `Multiple submission types match criteria for guest EC upload: ${submissionTypes
        .map(st => st.id)
        .join(", ")}`,
    );
  }

  return <CreateSubmission submissionTypeId={submissionTypes[0].id} />;
};

export default UploadElevationCertificatesPage;
